import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

interface ComparativaPorRolProps {
  data: Array<{
    rol: string;
    individual: number;
    equipo: number;
    organizacion: number;
  }>;
}

export function ComparativaPorRol({ data }: ComparativaPorRolProps) {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          Comparativa por Rol (Individual, Equipo, Organización)
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm border">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-4 py-2 border">Rol</th>
                <th className="px-4 py-2 border">Individual</th>
                <th className="px-4 py-2 border">Equipo</th>
                <th className="px-4 py-2 border">Organización</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row) => (
                <tr key={row.rol}>
                  <td className="px-4 py-2 border font-semibold">{row.rol}</td>
                  <td className="px-4 py-2 border text-blue-700">{row.individual.toFixed(2)}</td>
                  <td className="px-4 py-2 border text-purple-700">{row.equipo.toFixed(2)}</td>
                  <td className="px-4 py-2 border text-green-700">{row.organizacion.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
} 